import Swiper from "swiper";

class KitProfirSlider {
    constructor(section) {
        this.section = section;
        this.swiperContainer = this.section.querySelector(".js-kit-profit-swiper-container");
        this.controls = [];

        this._init();
    }

    _init() {
        this._findControls();
        this._initSlider();
    }

    _findControls() {
        this.controls = {
            buttonPrev: this.section.querySelector(".swiper-button-prev"),
            buttonNext: this.section.querySelector(".swiper-button-next"),
            pagination: this.section.querySelector(".swiper-pagination"),
        };
    }

    _initSlider() {
        const swiperOptions = {
            slidesPerView: 1,
            spaceBetween: 24,
            pagination: {
                el: this.controls.pagination,
                dynamicBullets: true,
                dynamicMainBullets: 3,
                clickable: true,
            },
            navigation: {
                prevEl: this.controls.buttonPrev,
                nextEl: this.controls.buttonNext,
            },
            breakpoints: {
                375: {
                    slidesPerView: 1.7,
                },
                385: {
                    slidesPerView: 1.8,
                },
                395: {
                    slidesPerView: 1.9,
                },
                415: {
                    slidesPerView: 2.0,
                },
                435: {
                    slidesPerView: 2.1,
                },
                455: {
                    slidesPerView: 2.2,
                },
                475: {
                    slidesPerView: 2.3,
                },
                495: {
                    slidesPerView: 2.4,
                },
                530: {
                    slidesPerView: 2.5,
                },
                570: {
                    slidesPerView: 2.7,
                },
                630: {
                    slidesPerView: 3.0,
                },
                670: {
                    slidesPerView: 3.5,
                },
                700: {
                    slidesPerView: 4.0,
                },
                768: {
                    slidesPerView: 4.2,
                },
            },
        };

        this.slider = new Swiper(this.swiperContainer, swiperOptions);
    }
}

const kitSections = document.querySelectorAll(".js-kit-profit-swiper-init");

if (kitSections) {
    for (const section of kitSections) {
        new KitProfirSlider(section);
    }
}
